import { Breadcrumb } from "antd";
import { Link } from "react-router-dom";
import type { ReactNode } from "react";

export interface Crumb {
  label: ReactNode;
  to?: string;
}

/** Breadcrumb cliccabile in testa alle pagine: Fornitori › fornitore › stabilimento › audit › evidenza. */
export function Crumbs({ items }: { items: Crumb[] }) {
  return (
    <Breadcrumb
      style={{ fontSize: 13, marginBottom: 4 }}
      separator="›"
      items={items.map((c, i) => ({ key: i, title: c.to && i < items.length - 1 ? <Link to={c.to}>{c.label}</Link> : c.label }))}
    />
  );
}
